import { Autocomplete, Box, InputAdornment, Modal, TextField } from "@mui/material";
import { useState } from "react";
import { deleteZero, handleNumber, handleZero, isValid } from "../../../helpers/helper";
import { AUTOCOMPLETE_STYLE, TEXTFIELD_STYLE } from "../../../constants/constants";
import { t } from "i18next";

const AddRateModal = ({
    open,
    setOpen,
    handleAdd,
    gradeCodes,
    rates,
    currencySymbol
}) => {
    const [gradeCode, setGradeCode] = useState(null)
    const [rate, setRate] = useState(0)

    const handleOnCloseModal = (event, reason) => {
        if (reason !== "backdropClick") {
            handleOnClose()
        }
    }

    const handleOnClose = () => {
        setOpen(false)
        initialize()
    }

    const handleClickAdd = (event) => {
        handleAdd(gradeCode, rate)
        setOpen(false)
        initialize()
    }

    const initialize = () => {
        setGradeCode(null)
        setRate(0)
    }

    return (
        <Modal open={open} onClose={(event, reason) => handleOnCloseModal(event, reason)}>
            <Box sx={style}>
                <div className='flex justify-between items-center p-5 w-full' style={{ backgroundColor: '#336195', borderRadius: '5px 5px 0 0' }}>
                    <div className='flex items-baseline justify-between w-full'>
                        <p className='text-[18px] font-[600] text-white'>Add Rate</p>
                        <div style={{ transform: "rotate(45deg)" }} className="font-[600] text-white">
                            <button onClick={handleOnClose}><i className="fa-solid fa-plus"></i></button>
                        </div>
                    </div>
                </div>

                <div className="p-5">
                    <div className="w-full pb-4">
                        <p className="text-[14px] text-[#718096]">{t('grade_code')}</p>
                        <Autocomplete
                            disablePortal
                            disableClearable
                            id="grade-code-rate-autocomplete"
                            options={gradeCodes?.map((type) => ({id: type?.id, label: t(type?.code)}))}
                            getOptionDisabled={(option) => rates.some((r) => r.grade_code_id === option.id)}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            sx={{
                                ...AUTOCOMPLETE_STYLE,
                                '.MuiOutlinedInput-input': {
                                    padding: '0 !important'
                                }
                            }}
                            onChange={(a, b) => setGradeCode({
                                id: b?.id,
                                code: b?.label
                            })}
                            renderInput={(params) => <TextField {...params} autoFocus={true} />}
                        />
                    </div>

                    <div className='w-full pb-4'>
                        <p className="text-[14px] text-[#718096]">{t('rate')} ({currencySymbol})</p>
                        <TextField
                            sx={TEXTFIELD_STYLE}
                            type="text"
                            name="rate"
                            value={rate}
                            disabled={!gradeCode}
                            onChange={(e) => handleNumber({
                                event: e,
                                setter: setRate,
                                precision: 2
                            })}
                            onBlur={e => handleZero({
                                event: e,
                                setter: setRate
                            })}
                            onFocus={e => deleteZero({
                                event: e,
                                setter: setRate,
                                value: rate
                            })}
                        />
                    </div>

                    <div className='w-full flex gap-2 justify-between'>
                        <button
                            type="button"
                            onClick={handleOnClose}
                            className='w-full text-[14px] text-[#919399] rounded-sm px-4 py-2 bg-[#F3F5F7] hover:bg-[#E6E6E6] disabled:bg-[#B8B7BC] capitalize'
                        >
                            {t('cancel')}
                        </button>
                        <button
                            type="button"
                            onClick={handleClickAdd}
                            disabled={!gradeCode}
                            className='w-full text-[14px] text-white rounded-sm px-4 py-2 bg-[#015D9F] hover:bg-[#003459] disabled:bg-[#B8B7BC] capitalize'
                        >
                            {t('add')}
                        </button>
                    </div>
                </div>
            </Box>
        </Modal>
    );
}

export default AddRateModal

const style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',
    maxWidth: '560px',
    height: 'fit-content',
    bgcolor: '#ffffff',
    border: 'transparent',
    borderRadius: '5px',
    boxShadow: 24,
    zIndex: "1600",
    outline: 'none'
}
